import type { SentryModule, SentryPathnameModuleRule } from '../types';

export const MODULE_ROUTE: Record<SentryModule, string> = {
  auth: '/login',
  landing: '/landing',
  landing_cdb: '/merchants',
  onboarding: '/onboarding',
  payment_links: '/payment-links',
  payment_forms: '/payment-forms',
  payment_buttons: '/payment-buttons',
  payments: '/transactions/payments',
  settlements: '/settlements',
  payouts: '/payout',
  developers: '/developers',
  disputes: '/transactions/disputes',
  reports: '/reports',
  orders: '/transactions/orders',
  refunds: '/transactions/refunds',
  summary: '/summary',
  settings: '/settings',
  offers: '/offers',
  one_click_checkout: '/one-click-checkout',
  easy_split: '/easy-split',
  softpos: '/softpos',
  customers: '/customers',
  customisation: '/customisation',
  subscriptions: '/subscriptions',
  risk_shield: '/risk-shield',
  vba: '/vba-configuration',
  // Ownership-only module for Home/Insights frontend default (PG)
  pg_team: '/summary/analytics/pg-default',
};

export const PATHNAME_MODULE_MAP: ReadonlyArray<SentryPathnameModuleRule> = [
  { prefix: '/merchants/landing', module: 'landing_cdb' },
  { prefix: '/vba-configuration', module: 'vba' },
  { prefix: '/transactions/suspicious', module: 'payments' },
  // Home / Insights without explicit metadata → PG (not CPSS; CPSS is backend-only)
  { prefix: '/summary/analytics', module: 'pg_team' },
  { prefix: '/summary/overview', module: 'pg_team' },
  ...Object.entries(MODULE_ROUTE)
    .map(([module, prefix]) => ({
      prefix,
      module: module as SentryModule,
    }))
    .sort((a, b) => b.prefix.length - a.prefix.length),
];
